import api from "../services/api";

export const submitOpportunityToRebel = async (projectKey, values) => {
    return api.put("/api/rebel-group/opportunity", { projectKey, ...values });
};
